import React, { useContext } from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  WrappedField,
  MaskedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

import FormContext from 'src/presentation/contexts/FormContext';

function RenderOrdergrooveConfiguration(
  onChange: (attr: string) => ChangeHandler,
  maskedFields: string[] = []
): JSX.Element {
  const { workingState } = useContext(FormContext);
  const secrets = (workingState as any)?.secrets || {};
  const hasLegacyAuth = !!secrets.hashKey || (secrets.hasSecrets || []).includes('hashKey');
  return (
    <>
      <CompactSection
        description={`The Ordergroove app enriches your customer pages with customer details and subscription information pulled from your Ordergroove instance.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="ordergroove-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.publicId"
            label="Ordergroove Merchant ID"
            description="This is the unique id of your shop in Ordergroove system. You can find it at https://rc3.ordergroove.com/keys"
            data-aid="ordergroove-public-id"
            onChange={onChange('connectionSettings.publicId')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.apiKey"
            label="Ordergroove API Key"
            description="This is the Ordergroove API Key used to authenticate requests to the Ordergroove API. You can find it at https://rc3.ordergroove.com/keys"
            data-aid="ordergroove-api-key"
            onChange={onChange('secrets.apiKey')}
            showClearButton={maskedFields.includes('apiKey')}
            isMasked={maskedFields.includes('apiKey')}
          />
        </Row>
        {!hasLegacyAuth ? null : (
          <CompactSection
            description="The below fields are deprecated and will be removed in a future release. If your App is still using this Legacy auth it will continue working. However, some features such as Actions will be only available when API key is set."
            header="Legacy Authentication"
          >
            <Row>
              <WrappedField
                attr="connectionSettings.apiUser"
                label="Ordergroove API User"
                description="This is the id of the Ordergroove user which will be used to perform requests"
                data-aid="ordergroove-api-user"
                onChange={onChange('connectionSettings.apiUser')}
                disabled={true}
              />
            </Row>
            <Row>
              <MaskedField
                attr="secrets.hashKey"
                label="Storefront API Key"
                description="This field is used to authenticate Ordergroove requests"
                data-aid="ordergroove-hash-key"
                onChange={onChange('secrets.hashKey')}
                isMasked={true}
                disabled={true}
              />
            </Row>
            <Row>
              <MaskedField
                attr="secrets.apiUserToken"
                label="Ordergroove API User Hash"
                description="This is the token for Ordergroove API user"
                data-aid="ordergroove-api-user-token"
                onChange={onChange('secrets.apiUserToken')}
                isMasked={true}
                disabled={true}
              />
            </Row>
          </CompactSection>
        )}
      </CompactSection>
    </>
  );
}

export default RenderOrdergrooveConfiguration;
